<template>
<div id="app" class="wrapper" style="padding-right: 2px; padding-left: 2px;">	
  <!-- Content Wrapper. Contains page content -->
  <div class="content-wrapper">       		
	  <div class="app">
			<br>
			<h3 class="title cor-preta">Produto selecionado:</h3>		  
			<div>
					<div>
						<table class="table">
							<thead>
								<tr>
									<th scope="col"><label class="cor-preta"><b>Produto</b></label></th>
									<th scope="col"><label class="cor-preta"><b>Preço</b></label></th>
								</tr>
							</thead>
								<tbody>
									<tr>
										<td><label class="cor-preta" ><b>{{product.nm}}</b></label></td>
										<td><label class="cor-preta" ><b>R$ {{product.vl}}</b></label></td>
									</tr>
								</tbody>								
						</table>
					</div>
							
					<div  class="col-md-14">
						<div>
								<label class="cor-preta"><b>Escolha os sabores</b></label><br>
						</div>			
					</div>
							
					<div class="col-md-14">					
						<div v-if="product.qtd >= '0'">
							<label class="cor-preta"><b class="letra-pequena">Você pode selecionar {{ product.qtd }} sabores.</b></label><br>
						</div>
						<div v-else>
							<label class="cor-preta"><b class="letra-pequena">Selecione quantos sabores você quiser.</b></label><br>
						</div>
					</div>
							
					<div id="listandoordem">
						<table class="table">
							<thead>
								<tr>
								  <th scope="col"><label class="cor-preta"><b></b></label></th>
									<th scope="col"><label class="cor-preta"><b>Opções</b></label></th>
									<th scope="col"><label class="cor-preta"><b>Ingredientes</b></label></th>
									<th scope="col"><label class="cor-preta"><b>Preço</b></label></th>							
								</tr>
							</thead>
								<tbody v-for="sabor of sabores" :key="sabor.cd">
								 <tr>
									  <td align="center">													
										  <input type="checkbox" :id="sabor" :value="sabor" v-model="checkedNames"></input>
									  </td>
									  <td>{{ sabor.nm }}</td>
									  <td>{{ sabor.ingredientes }}</td>
									  <td>R$ {{ sabor.vl }}</td>
									</tr>
								</tbody>								
							</table>
						</div>	
			</div>
		</div>
    <div class="modal-footer">
    <table border=0>
					<thead>
					<tr>
					<td width="350" valign="top">
						<li align="left">
						<button style="background-color:#dc3545;" @click="voltar()"  type="button" class="btn btn-dark">Voltar</button>
            </li>
					</td>
					<td width="100">
						<li align="center">
						</li>
					</td>
					<td width="480" valign="top">
						<li align="right">				
						<button style="background-color:#006400 ;" @click="continuar()"  type="button" class="btn btn-dark">Continuar</button>
						</li>
					</td>
					</tr>
					</thead>
				</table>
    </div>
	</div>
	<br>
	<footer class="main-footer" align="center">
    <b class="cor-preta">Todos os direitos reservados.</b><br>
    <b class="cor-preta">&copy; 2022 <a target=”_blank” href="https://www.panterafood.com.br">Pantera Food</a>.</b><br>
	<img width="100" src="https://apppanterafood.com.br/DeliveryCenter/3/logo/pantera.svg">
	</footer>
</div>
</template>
<script>
import { mapGetters, mapActions } from "vuex";
import Ordem from "../services/nome_ordem";
import Sabor from "../services/sabor";
import Inis from "../services/inis";
import Swal from "sweetalert2";

import SecureLS from 'secure-ls';
var ls = new SecureLS({encodingType: 'aes'});


export default {
  name: "PerguntasPizza",
  data() {
    return {
      obs: [],
      product: [],
      checkedNames: [],
      adicionaispergunta: [],
      search: "",
      product: {
        cd: "",
        nm: "",
        classe: "",
        ingredientes: "",
        vl: "",
      },
      nome_ordens: [],
      nome_ordem: {
        cd: "",
        nm: "",
        ordem: "",
        cd_prod: "",
        selecao: "",
      },
      adicionais: [],
      adicional: {
        cd: "",
        cd_prod: "",
        qtd: "",
        vl: "",
        tipo: "",
        nm: "",
        cd_sabor: "",
        ordem: "",
        obs: "",
        cd_prod_pai: "",
      },
      inis: {
        cd: "",
        vl: "",
        dt_ins: "",
        desc_config: "",
      },
      cdproduto: "",
      nmproduto: "",
      vlproduto: "",
      ingredientesproduto: "",
      classeproduto: "",
      index: 0,
      sabores: [],
    };
  },
  computed: {
    ...mapGetters({
      //adicionais: 'allAdicionais',
      length: "getNumberOfProducts",
    }),
  },
  methods: {
    voltar() {
      this.$router.push("/");
    },
    continuar() {
  
      if(this.checkedNames.length==0){
        Swal.fire({
          title:
            "Escolha ao menos 1 sabor",
          confirmButtonColor: "#000000",
        });
      }else if (this.product.qtd < this.checkedNames.length) {
        Swal.fire({
          title:
            "Você pode selecionar no máximo " +
            this.product.qtd +
            " sabor(es).",
          confirmButtonColor: "#000000",
        });
      } else {
        var valorAux = 0;
        this.inis.forEach((inis) => {
          //VALOR MAIOR
          if (inis.cd === "PIZZA" && inis.vl === "3") {
            this.checkedNames.forEach((sabores) => {
              
              sabores.vl = parseFloat(sabores.vl)
                 
              if (sabores.vl >= valorAux) {              
                valorAux = sabores.vl;            
                sabores.vl = 0;           
              }else{
                sabores.vl = 0;                    
              }
            });
            this.checkedNames[0].vl = valorAux;
            
            ls.set('sabores'+ process.env.VUE_APP_CONTRATO,JSON.parse(JSON.stringify(this.checkedNames)))
         //MEDIA DOS SABORES
         } else if (inis.cd === "PIZZA" && inis.vl === "2") {
            var i = 0;
            this.checkedNames.forEach((sabores) => {
              valorAux = valorAux + parseInt(sabores.vl);
              sabores.vl=0
              i = i + 1;
            });
            this.checkedNames[0].vl = valorAux / i;
            
            ls.set('sabores'+ process.env.VUE_APP_CONTRATO,JSON.parse(JSON.stringify(this.checkedNames)))
          //VALOR DO PRODUTO
          }else if(inis.cd === "PIZZA" && inis.vl === "1"){
            this.checkedNames.forEach((sabores) => {
              sabores.vl=0
            });
            
            ls.set('sabores'+ process.env.VUE_APP_CONTRATO,JSON.parse(JSON.stringify(this.checkedNames)))
          }
        });
        this.$router.push("/perguntas");
      }
    },
    listarproduto() {
      this.product = ls.get('product'+ process.env.VUE_APP_CONTRATO)

      //alert('Produto Selecionado Adicional: '+this.product);
      Ordem.verificaordem(this.product.cd).then((resposta) => {
        this.nome_ordens = resposta.data.filter(ordem=>{
            return ordem.ativo=="1"
            })
      });
    },
    listarSabores() {
      this.product = ls.get('product'+ process.env.VUE_APP_CONTRATO)
      Sabor.verificasabor(this.product.cd).then((resposta) => {
        this.sabores = resposta.data.filter(sabor=>{
            return sabor.ativo=="1"
            })
      });
    },
    listarinis() {
      Inis.listarinis().then((resposta) => {
        this.inis = resposta.data;
      });
    },

    ...mapActions(["addToCart"]),
  },
  mounted() {
    this.listarproduto();
    this.listarinis();
    this.listarSabores();
  },
};
</script>